import React, { useEffect, useState } from "react";
import { Layout } from "@/components/Layout";
import { HeroBillboard } from "@/components/HeroBillboard";
import { ContentRow } from "@/components/ContentRow";
import { RowSkeleton, HeroSkeleton } from "@/components/Skeletons";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function Home() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [continueW, setContinueW] = useState([]);

  useEffect(() => {
    api.get("/home").then((r) => setData(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (user) api.get("/continue-watching").then((r) => setContinueW(r.data)).catch(() => {});
    else setContinueW([]);
  }, [user]);

  return (
    <Layout>
      {!data ? (
        <>
          <HeroSkeleton />
          <div className="-mt-24 relative z-10"><RowSkeleton /><RowSkeleton /></div>
        </>
      ) : (
        <>
          <HeroBillboard item={data.hero} />
          <div className="relative z-10 -mt-16 md:-mt-24">
            {continueW.length > 0 && <ContentRow title="Continue Watching" items={continueW} />}
            {data.sections.map((s) => (
              <ContentRow key={s.key} title={s.title} items={s.items} ranked={s.ranked} />
            ))}
          </div>
        </>
      )}
    </Layout>
  );
}
